module.exports = __webpack_public_path__ + "static/media/21_online.824beeec.gif";